module.exports = __webpack_public_path__ + "media/Video 3.f9f4129d.mp4";